import store from 'store2';

/**
 * APIs
 */
import { me } from '@/apis/auth';

export function initAuth(redirect: string = encodeURIComponent(window.location.href)) {
    const params = new URLSearchParams(window.location.search);

    let accessToken = params.get('access_token');

    if (accessToken) {
        params.delete('access_token');

        window.history.replaceState({}, '', window.location.pathname + (params.size ? '?' + params.toString() : ''));

        if (!isExpired(accessToken)) {
            store.set('accessToken', accessToken);

            return;
        }
    }

    accessToken = store.get('accessToken');

    if (accessToken && !isExpired(accessToken)) {
        return;
    }

    window.location.href = `${import.meta.env.VITE_LOGIN}?redirect=${redirect}`;
}

export function isExpired(token: string) {
    let payload;

    try {
        payload = JSON.parse(window.atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    } catch {}

    return !payload || payload.exp * 1000 < Date.now();
}

export async function syncUser() {
    const user = store.get('user');

    if (user) {
        me()
            .then(({ data }) => {
                store(data.data);
            })
            .catch(console.error);
    } else {
        store((await me()).data.data);
    }
}
